import { log } from "@/lib/Debug";
import MobileDetect from "mobile-detect";

let device = "Node";

/** AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS, iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS */
export const getDevice = () => {
  checkDevice();
  return device;
};

export const checkDevice = () => {
  if (import.meta.env.SERVER) {
    return;
  }
  const md = new MobileDetect(window.navigator.userAgent);
  device = md.os();
  if (
    !device &&
    /Macintosh/i.test(navigator.userAgent) &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 1
  ) {
    device = "iPadOS";
  }
  log("checkDevice", device);
};

export default { getDevice, checkDevice};
